import { FileInput } from '@mantine/core';
import cx from 'clsx';
import { FC, memo, useEffect, useState } from 'react';
import defaultStyles from 'src/components/Form/styles.default.module.css';
import { Icon } from 'src/components/Icon';
import { useFormContext } from 'src/form';

import styles from './styles.module.css';

type Props = {
  label: string;
  name: string;
  width?: number | string;
  height?: number | string;
};

export const InputFile: FC<Props> = memo((props) => {
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);

  const form = useFormContext();
  const formProps = form.getInputProps(props.name);

  useEffect(() => {
    const value = formProps.value;

    if (!value) {
      if (previewUrl) {
        URL.revokeObjectURL(previewUrl);
      }
      setPreviewUrl(null);
      return;
    }

    if (value instanceof File) {
      const url = URL.createObjectURL(value);
      setPreviewUrl(url);
    } else if (typeof value === 'string') {
      setPreviewUrl(value);
    }
  }, [formProps.value]);

  const valueComponent: FC<{ value: File | File[] | null }> = ({ value }) => {
    if (!value) return null;

    const file = Array.isArray(value) ? value[0] : value;
    if (!file) return null;

    return (
      <div className={styles.previewContainer}>
        <img
          src={previewUrl || undefined}
          alt="Preview"
          className={styles.preview}
        />
      </div>
    );
  };

  const inputStyles = props.height
    ? { height: `${props.height}px`, width: `${props.width}px` }
    : {};

  return (
    <FileInput
      classNames={{
        input: cx(defaultStyles.input, styles.fileInput),
        label: defaultStyles.label,
        placeholder: styles.placeholder,
      }}
      styles={{
        input: inputStyles,
        wrapper: inputStyles,
      }}
      clearable={true}
      clearButtonProps={{
        className: styles.clearButton,
      }}
      accept="image/png,image/jpeg"
      valueComponent={valueComponent}
      error={formProps.error}
      {...props}
      {...formProps}
      placeholder={<Icon className={styles.uploadIcon} name="upload" />}
    />
  );
});
